import * as React from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import useSearchProfiles from '../../hooks/useSearchProfiles';
import { RouteComponentProps } from 'react-router';
import { Link } from 'react-router-dom';
import { body2Size } from '../../theme';

const useStyles = makeStyles(() =>
    createStyles({
        formControl: {
            marginTop: -8,
            minWidth: 120,
        },
        defaultNav: {
            marginBottom: -4,
            '& a': {
                marginLeft: 18,
                fontSize: body2Size
            },

            // TODO: add to <Menu>?
            '@media (max-width: 500px)': {
                '& a': {
                    display: 'none'
                }
            }
        }
    })
);

function JobsNav({match, history}: RouteComponentProps<{profileName?: string}>) {
    const [profiles, profile, setProfile] = useSearchProfiles('jobs', match && match.params.profileName);
    const classes = useStyles();
    // console.info('JobsNav match:', match && match.params, profile);

    function onProfile(e: React.ChangeEvent<{value: string}>) {
        console.info('selected profile ID:', e.target.value);
        for (const p of profiles!) {
            if (p.id === e.target.value) {
                setProfile(p);
                history.push(p.default ? '/jobs' : `/jobs/search-profile/${p.name}`);
            }
        }
    }

    if (false && profile) {
        return (
            <FormControl className={classes.formControl}>
                <InputLabel shrink htmlFor="search-profile">Job search</InputLabel>
                <Select displayEmpty value={profile!.id} onChange={onProfile} inputProps={{id: 'search-profile'}}>
                    {profiles && profiles!.map(p =>
                        <MenuItem value={p.id} key={p.id} >{p.name}</MenuItem>
                    )}
                    <MenuItem value="">Create new profile...</MenuItem>
                </Select>
            </FormControl>
        );
    } else {
        return (
            <span className={classes.defaultNav}>
                job search
                <Link to="/talent">Employers - find talent</Link>
            </span>
        );
    }
}

export default JobsNav;
